import { render } from "./App.vue?vue&type=template&id=47c728b1"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=47c728b1&lang=css"

import exportComponent from "/Users/bettachristian-david/Documents/Accen/Gestion conge/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__